import * as types from './fundingBody.types'

const initialState = {
	isLoading: false,
	isSuccess: false,
	fundingBody: {
		body_id: null,
	},
	options: {},
	permissions: {},
	canBeCreatFundingBody: false,
}

export const reducer = (state = initialState, action) => {
	const { type, payload } = action
	switch (type) {
		case types.TOGGLE_LOADING:
			return {
				...state,
				isLoading: payload,
			}
		case types.SET_FUNDINGBODY:
			return {
				...state,
				fundingBody: payload,
			}
		case types.TOGGLE_SUCCESS:
			return {
				...state,
				isSuccess: payload,
			}
		case types.SET_OPTIONS:
			return {
				...state,
				options: payload,
			}
		case types.CLEAR_DATA:
			return {
				...state,
				fundingBody: initialState.fundingBody,
			}
		case types.SET_PERMISSIONS:
			return {
				...state,
				permissions: payload,
			}
		case types.SET_CAN_BE_CREATED:
			return {
				...state,
				canBeCreatFundingBody: payload,
			}
		default:
			return state
	}
}
